import {
	userConstants
}from "../constants/user"

const initialState = {
	//login
	user         : { isLoggedIn: false },
	loginLoading : false,
	loginError   : null,

	//logout
	logoutLoading: false,

	//refresh token
	refreshTokenLoading: false
}

export default function (state = initialState, action){
	switch (action.type){
		case userConstants.Login.REQUEST: {
			return {
				...state,
				loginLoading : true,
				user         : { isLoggedIn: false }
			}
		}
		case userConstants.Login.SUCCESS: {
			const user = action.payload.result
			window.localStorage.setItem("user", JSON.stringify({
				token        : user.token,
				refreshToken : user.refreshToken,
				userName     : user.userName
			}))

			return {
				...state,
				loginLoading : false,
				user         : {
					...action.payload.result,
					isLoggedIn: true
				}
			}
		}
		case userConstants.Login.FAILURE: {
			return {
				...state,
				loginLoading : false,
				loginError   : action.payload
			}
		}

		case userConstants.Logout.REQUEST: {
			return {
				...state,
				logoutLoading: true
			}
		}
		case userConstants.Logout.SUCCESS: {
			window.localStorage.removeItem("user")
			window.localStorage.removeItem("lastActiveTab")

			return {
				...state,
				logoutLoading : false,
				user          : { isLoggedIn: false }
			}
		}
		case userConstants.Logout.FAILURE: {
			return {
				...state,
				logoutLoading : false,
				user          : { isLoggedIn: false }
			}
		}

		case userConstants.RefreshUserData.REQUEST: {
			return {
				...state,
				refreshTokenLoading : true,
				user                : { isLoggedIn: false }
			}
		}
		case userConstants.RefreshUserData.SUCCESS: {
			const user = action.payload.result
			window.localStorage.setItem("user", JSON.stringify({
				token        : user.token,
				refreshToken : user.refreshToken,
				userName     : user.userName
			}))

			return {
				...state,
				refreshTokenLoading : false,
				user                : {
					...user,
					isLoggedIn: true
				}
			}
		}
		case userConstants.RefreshUserData.FAILURE: {
			return {
				...state,
				refreshTokenLoading: false
			}
		}

		case userConstants.LoginClearError: {
			return {
				...state,
				loginError: null
			}
		}

		default:
			return state
	}
}